"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIST_PROMPTS = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const route_1 = require("../route");
const firestore_1 = require("firebase/firestore");
const firebase_app_1 = __importDefault(require("common/firebase-app"));
require("./style.css");
const axios_1 = __importDefault(require("axios"));
const auth_1 = require("common/auth");
// エンドポイント設定
const API_ENDPOINT = `https://asia-northeast1-${firebase_app_1.default.options.projectId}.cloudfunctions.net/endpoint`;
// デフォルトのモデル設定
const DEFAULT_MODEL = "gpt-4o";
exports.LIST_PROMPTS = route_1.PROMPT.sub("/list", PromptList);
function PromptList() {
    const { projectId } = (0, react_router_dom_1.useParams)();
    const [promptList, setPromptList] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const [editingPrompt, setEditingPrompt] = (0, react_1.useState)(null);
    const [formData, setFormData] = (0, react_1.useState)({
        prompt_text: "",
        prompt_inputs: "[]",
        prompt_title: "",
    });
    // 入力項目管理用の新しいステート
    const [inputItems, setInputItems] = (0, react_1.useState)([]);
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const firestore = (0, firestore_1.getFirestore)(firebase_app_1.default);
    const { user } = (0, auth_1.useAdminAuthentication)();
    // 実行用の状態
    const [isExecuteModalOpen, setIsExecuteModalOpen] = (0, react_1.useState)(false);
    const [executingPrompt, setExecutingPrompt] = (0, react_1.useState)(null);
    const [executeInputs, setExecuteInputs] = (0, react_1.useState)({});
    const [executionResult, setExecutionResult] = (0, react_1.useState)("");
    const [isExecuting, setIsExecuting] = (0, react_1.useState)(false);
    const [correctionText, setCorrectionText] = (0, react_1.useState)("");
    // Knowledge関連の状態
    const [knowledgeList, setKnowledgeList] = (0, react_1.useState)([]);
    const [selectedKnowledge, setSelectedKnowledge] = (0, react_1.useState)([]);
    const [isSelectingKnowledge, setIsSelectingKnowledge] = (0, react_1.useState)(false);
    // 学習用の状態
    const [isLearning, setIsLearning] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        fetchPrompts();
        fetchKnowledge();
    }, [projectId, firestore]);
    const fetchPrompts = () => __awaiter(this, void 0, void 0, function* () {
        if (!projectId)
            return;
        try {
            setLoading(true);
            const promptQuery = (0, firestore_1.query)((0, firestore_1.collection)(firestore, "prompt"), (0, firestore_1.where)("project_id", "==", projectId));
            const snapshot = yield (0, firestore_1.getDocs)(promptQuery);
            const prompts = snapshot.docs.map((doc) => (Object.assign({ id: doc.id }, doc.data())));
            setPromptList(prompts);
            setError(null);
        }
        catch (err) {
            console.error("プロンプトデータの取得に失敗しました:", err);
            setError("プロンプトデータの取得に失敗しました");
        }
        finally {
            setLoading(false);
        }
    });
    // Knowledgeデータの取得
    const fetchKnowledge = () => __awaiter(this, void 0, void 0, function* () {
        if (!projectId)
            return;
        try {
            const knowledgeQuery = (0, firestore_1.query)((0, firestore_1.collection)(firestore, "knowledge"), (0, firestore_1.where)("project_id", "==", projectId));
            const snapshot = yield (0, firestore_1.getDocs)(knowledgeQuery);
            const knowledge = snapshot.docs.map((doc) => (Object.assign({ id: doc.id }, doc.data())));
            setKnowledgeList(knowledge);
        }
        catch (err) {
            console.error("知識データの取得に失敗しました:", err);
        }
    });
    const openCreateModal = () => {
        setFormData({
            prompt_text: "",
            prompt_inputs: "[]",
            prompt_title: "",
        });
        setInputItems([{ input_id: 1, input_name: "" }]);
        setEditingPrompt(null);
        setIsModalOpen(true);
    };
    const openEditModal = (prompt) => {
        setFormData({
            prompt_text: prompt.prompt_text,
            prompt_inputs: JSON.stringify(prompt.prompt_inputs),
            prompt_title: prompt.prompt_title || "",
        });
        // 既存の入力項目を設定
        setInputItems(prompt.prompt_inputs.map((item) => ({
            input_id: item.input_id,
            input_name: item.input_name,
        })));
        setEditingPrompt(prompt);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setEditingPrompt(null);
    };
    // 実行モーダルを開く
    const openExecuteModal = (prompt) => {
        setExecutingPrompt(prompt);
        // 入力フィールド初期化
        const initialInputs = {};
        prompt.prompt_inputs.forEach((input) => {
            initialInputs[input.input_id] = "";
        });
        setExecuteInputs(initialInputs);
        setExecutionResult("");
        setCorrectionText("");
        setIsExecuteModalOpen(true);
    };
    // 実行モーダルを閉じる
    const closeExecuteModal = () => {
        setIsExecuteModalOpen(false);
        setExecutingPrompt(null);
        setExecutionResult("");
        setCorrectionText("");
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => (Object.assign(Object.assign({}, prev), { [name]: value })));
    };
    // 入力項目名の変更ハンドラ
    const handleInputItemChange = (index, value) => {
        const newInputItems = [...inputItems];
        newInputItems[index].input_name = value;
        setInputItems(newInputItems);
    };
    // 実行用の入力フィールド変更ハンドラ
    const handleExecuteInputChange = (e, inputId) => {
        const { value } = e.target;
        setExecuteInputs((prev) => (Object.assign(Object.assign({}, prev), { [inputId]: value })));
    };
    // 入力項目の追加
    const addInputItem = () => {
        // 新しいIDは既存の最大ID + 1
        const newId = inputItems.length > 0
            ? Math.max(...inputItems.map((item) => item.input_id)) + 1
            : 1;
        setInputItems([...inputItems, { input_id: newId, input_name: "" }]);
    };
    // 入力項目の削除
    const removeInputItem = (index) => {
        const newInputItems = [...inputItems];
        newInputItems.splice(index, 1);
        setInputItems(newInputItems);
    };
    // プロンプトテキストに入力参照を挿入する
    const insertInputReference = (inputId) => {
        const cursorPosition = document.querySelector('textarea[name="prompt_text"]');
        if (!cursorPosition)
            return;
        const startPos = cursorPosition.selectionStart;
        const endPos = cursorPosition.selectionEnd;
        const textBefore = formData.prompt_text.substring(0, startPos);
        const textAfter = formData.prompt_text.substring(endPos);
        const insertText = `入力${inputId}`;
        setFormData(Object.assign(Object.assign({}, formData), { prompt_text: textBefore + insertText + textAfter }));
        // フォーカスを戻す（非同期で実行）
        setTimeout(() => {
            cursorPosition.focus();
            cursorPosition.setSelectionRange(startPos + insertText.length, startPos + insertText.length);
        }, 0);
    };
    const handleSubmit = (e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        if (!projectId)
            return;
        try {
            setIsSubmitting(true);
            // prompt_titleのバリデーション
            if (!formData.prompt_title.trim()) {
                alert("プロンプトタイトルを入力してください");
                setIsSubmitting(false);
                return;
            }
            // 入力項目のバリデーション
            if (inputItems.some((item) => !item.input_name.trim())) {
                alert("入力項目名を空にすることはできません");
                setIsSubmitting(false);
                return;
            }
            // 入力項目をJSON形式に変換
            const promptInputs = inputItems.map((item) => ({
                input_id: item.input_id,
                input_name: item.input_name,
                is_multiple: false,
            }));
            if (editingPrompt) {
                // 更新処理
                yield (0, firestore_1.updateDoc)((0, firestore_1.doc)(firestore, "prompt", editingPrompt.id), {
                    prompt_title: formData.prompt_title,
                    prompt_text: formData.prompt_text,
                    prompt_inputs: promptInputs,
                    updatedAt: (0, firestore_1.serverTimestamp)(),
                });
            }
            else {
                // 新規作成処理
                yield (0, firestore_1.addDoc)((0, firestore_1.collection)(firestore, "prompt"), {
                    project_id: projectId,
                    prompt_title: formData.prompt_title,
                    prompt_text: formData.prompt_text,
                    prompt_inputs: promptInputs,
                    createdAt: (0, firestore_1.serverTimestamp)(),
                });
            }
            closeModal();
            fetchPrompts();
        }
        catch (err) {
            console.error("プロンプトデータの保存に失敗しました:", err);
            alert("プロンプトデータの保存に失敗しました");
        }
        finally {
            setIsSubmitting(false);
        }
    });
    // プロンプト実行ハンドラ
    const handleExecute = (e) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        e.preventDefault();
        if (!executingPrompt || !projectId)
            return;
        try {
            setIsExecuting(true);
            // プロンプトテキストに入力データを埋め込む
            let executedPrompt = executingPrompt.prompt_text;
            // 入力データをプロンプトに埋め込む
            for (const input of executingPrompt.prompt_inputs) {
                executedPrompt = executedPrompt.replace(`{${input.input_name}}`, executeInputs[input.input_id] || "");
            }
            // APIキーを取得
            const apiKeyDoc = yield (0, firestore_1.getDoc)((0, firestore_1.doc)(firestore, "scenario_project", projectId, "key", (user === null || user === void 0 ? void 0 : user.email) || ""));
            const apiKey = (_a = apiKeyDoc.data()) === null || _a === void 0 ? void 0 : _a.key;
            if (!apiKey) {
                throw new Error("APIキーが見つかりません");
            }
            // Knowledgeがあれば、役立つものを選択するリクエストを送信
            if (knowledgeList.length > 0) {
                setIsSelectingKnowledge(true);
                // 名前と内容の一覧を作成
                const knowledgeInfoList = knowledgeList.map((k) => ({
                    id: k.id,
                    name: k.name,
                    knowledge: k.knowledge,
                    condition: k.condition,
                }));
                // 最初のリクエスト - 役立つKnowledgeを選択
                const selectKnowledgeRequest = {
                    projectId: projectId,
                    messages: [
                        {
                            role: "user",
                            content: `以下のプロンプトと入力情報に対して、役立ちそうなKnowledgeがあれば最大10件選んでください。
              
プロンプト:
${executedPrompt}

入力情報:
${Object.entries(executeInputs)
                                .map(([key, value]) => { var _a, _b; return `### 入力${(_a = executingPrompt.prompt_inputs.find((input) => input.input_id === parseInt(key))) === null || _a === void 0 ? void 0 : _a.input_id} - ${(_b = executingPrompt.prompt_inputs.find((input) => input.input_id === parseInt(key))) === null || _b === void 0 ? void 0 : _b.input_name}:\n${value}`; })
                                .join("\n\n")}

利用可能なKnowledge:
${JSON.stringify(knowledgeInfoList, null, 2)}

応答は以下の形式のJSONで返してください。ただし、開始マーカー (\`\`\`json) と終了マーカー (\`\`\`) は含めないでください。
{
  "selected_knowledge_ids": ["id1", "id2", ...]
}`,
                        },
                    ],
                    model: DEFAULT_MODEL,
                };
                // Knowledgeを選択するリクエスト送信
                const selectResponse = yield axios_1.default.post(API_ENDPOINT, selectKnowledgeRequest, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${apiKey}`,
                    },
                });
                const selectResponseData = selectResponse.data;
                const selectResultContent = ((_c = (_b = selectResponseData.choices[0]) === null || _b === void 0 ? void 0 : _b.message) === null || _c === void 0 ? void 0 : _c.content) || "{}";
                console.log(selectResultContent);
                try {
                    // JSONをパース
                    const selectedKnowledgeResult = JSON.parse(selectResultContent);
                    if (selectedKnowledgeResult.selected_knowledge_ids &&
                        Array.isArray(selectedKnowledgeResult.selected_knowledge_ids)) {
                        // 選択されたIDに基づいてKnowledgeオブジェクトをフィルタリング
                        const selected = knowledgeList.filter((k) => selectedKnowledgeResult.selected_knowledge_ids.includes(k.id));
                        setSelectedKnowledge(selected);
                    }
                }
                catch (err) {
                    console.error("Knowledgeの選択結果のパースに失敗しました:", err);
                }
                setIsSelectingKnowledge(false);
            }
            // 元のリクエストを準備する
            let mainRequestContent = `${executedPrompt}\n\n\n${Object.entries(executeInputs)
                .map(([key, value]) => { var _a; return `### 入力${(_a = executingPrompt.prompt_inputs.find((input) => input.input_id === parseInt(key))) === null || _a === void 0 ? void 0 : _a.input_id}\n\n${value}\n\n\n\n`; })
                .join("\n\n\n")}`;
            // 選択されたKnowledgeがあれば、それを追加
            if (selectedKnowledge.length > 0) {
                mainRequestContent += `\n\n### 参考知識\n\n${selectedKnowledge
                    .map((k) => `【${k.name}】\n${k.knowledge}`)
                    .join("\n\n")}\n\n`;
            }
            mainRequestContent += `なお、回答は要求された出力のみを含め、それ以外の情報 (説明など) は一切加えないこと。`;
            // メインリクエストを構築
            const requestBody = {
                projectId: projectId,
                messages: [
                    {
                        role: "user",
                        content: mainRequestContent,
                    },
                ],
                model: DEFAULT_MODEL,
            };
            // エンドポイント呼び出し
            const response = yield axios_1.default.post(API_ENDPOINT, requestBody, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiKey}`,
                },
            });
            const responseData = response.data;
            // レスポンスから結果テキストを取得
            const resultContent = ((_e = (_d = responseData.choices[0]) === null || _d === void 0 ? void 0 : _d.message) === null || _e === void 0 ? void 0 : _e.content) || "応答が空でした";
            // 使用量情報を表示
            const usageInfo = responseData.usage
                ? `\n\n【トークン使用量】\nプロンプト: ${responseData.usage.prompt_tokens} トークン\n応答: ${responseData.usage.completion_tokens} トークン\n合計: ${responseData.usage.total_tokens} トークン`
                : "";
            // Knowledgeの使用状況も追加
            const knowledgeInfo = selectedKnowledge.length > 0
                ? `\n\n【使用された知識】\n${selectedKnowledge.map((k) => k.name).join(", ")}`
                : "\n\n【使用された知識】\nなし";
            // 結果を表示用に整形
            const formattedResult = `【実行結果】\n\n${resultContent}${usageInfo}${knowledgeInfo}`;
            setExecutionResult(formattedResult);
        }
        catch (err) {
            console.error("プロンプト実行に失敗しました:", err);
            setExecutionResult("実行中にエラーが発生しました: " +
                (err instanceof Error ? err.message : String(err)));
        }
        finally {
            setIsExecuting(false);
            setSelectedKnowledge([]);
        }
    });
    const handleDelete = (id) => __awaiter(this, void 0, void 0, function* () {
        if (!window.confirm("本当にこのプロンプトを削除しますか？"))
            return;
        try {
            setLoading(true);
            yield (0, firestore_1.deleteDoc)((0, firestore_1.doc)(firestore, "prompt", id));
            fetchPrompts();
        }
        catch (err) {
            console.error("プロンプトデータの削除に失敗しました:", err);
            alert("プロンプトデータの削除に失敗しました");
        }
        finally {
            setLoading(false);
        }
    });
    // プロンプト入力を表示するヘルパー関数
    const renderPromptInputs = (inputs) => {
        if (!inputs || inputs.length === 0) {
            return react_1.default.createElement("div", null, "\u5165\u529B\u306A\u3057");
        }
        return (react_1.default.createElement("div", null, inputs.map((input, index) => (react_1.default.createElement("div", { key: index, className: "tag is-info mr-2 mb-1" }, input.input_name)))));
    };
    // 校正テキスト変更ハンドラ
    const handleCorrectionChange = (e) => {
        setCorrectionText(e.target.value);
    };
    // 学習ボタンハンドラ
    const handleLearn = () => __awaiter(this, void 0, void 0, function* () {
        var _f, _g;
        if (!executingPrompt || !projectId)
            return;
        try {
            // 学習中の状態を追加
            setIsLearning(true);
            // AIの出力部分を抽出（使用量情報を除く）
            const aiOutputContent = executionResult.includes("【実行結果】\n\n")
                ? executionResult
                    .split("【実行結果】\n\n")[1]
                    .split("\n\n【トークン使用量】")[0]
                : executionResult;
            // input_idをキーとした入力データをログ出力
            const inputData = {};
            executingPrompt.prompt_inputs.forEach((input) => {
                inputData[input.input_id] = executeInputs[input.input_id] || "";
            });
            // APIキーを取得
            const apiKeyDoc = yield (0, firestore_1.getDocs)((0, firestore_1.query)((0, firestore_1.collection)(firestore, `scenario_project/${projectId}/key`), (0, firestore_1.limit)(1)));
            if (apiKeyDoc.empty) {
                throw new Error("APIキーが見つかりません");
            }
            const apiKey = apiKeyDoc.docs[0].data().key;
            // 知識ベース更新のリクエストを構築
            const learnRequestContent = {
                projectId: projectId,
                messages: [
                    {
                        role: "user",
                        content: `以下の情報に基づいて、知識ベースの更新が必要かどうかを判断してください。
            
プロンプト:
${executingPrompt.prompt_text}

入力情報:
${Object.entries(inputData)
                            .map(([id, value]) => { var _a; return `### ${(_a = executingPrompt.prompt_inputs.find((input) => input.input_id === parseInt(id))) === null || _a === void 0 ? void 0 : _a.input_name}:\n${value}`; })
                            .join("\n\n")}

使用された知識:
${selectedKnowledge.length > 0
                            ? selectedKnowledge.map((k) => `【${k.name}】\n${k.knowledge}`).join("\n\n")
                            : "なし"}

AIの出力:
${aiOutputContent}

ユーザーの修正:
${correctionText || "修正なし"}

利用可能な全知識:
${JSON.stringify(knowledgeList.map((k) => ({
                            id: k.id,
                            name: k.name,
                            condition: k.condition,
                            knowledge: k.knowledge,
                        })), null, 2)}

以下の分析を行ってください：
1. 新しい知識が必要かどうか
2. 既存の知識の修正が必要かどうか

応答は以下の形式のJSONで返してください：
{
  "new_knowledge": [
    {
      "name": "新しい知識の名前",
      "condition": "この知識を適用する条件",
      "knowledge": "知識の内容"
    }
  ],
  "update_knowledge": [
    {
      "id": "更新する知識のID",
      "name": "更新後の名前（変更なしの場合は同じ）",
      "condition": "更新後の条件（変更なしの場合は同じ）",
      "knowledge": "更新後の内容（変更なしの場合は同じ）"
    }
  ]
}

注意：
- 新しい知識が不要な場合は、new_knowledgeを空の配列にしてください
- 既存の知識の更新が不要な場合は、update_knowledgeを空の配列にしてください
- 必要がない場合は両方とも空の配列にしてください
- 知識はなるべく一般的にした方が望ましいです。可能なら抽象化してください (より広い範囲に使える知識にしていく)
- ただし、あまりに一般的 (例: 句読点に注意する) は使えません。句読点として「。」の代わりに「.」を使う、などが望ましいでしょう
- てにをはや、かっこの使い方や語尾、間の開け方などにも注目してください
- 校正がなくとも、暗に示された新たな情報 (例: 人間関係など) があれば、それらも知識として追加していきましょう

なお、出力には開始マーカー (\`\`\`json) と終了マーカー (\`\`\`) を含めないでください`,
                    },
                ],
                model: DEFAULT_MODEL,
            };
            // 学習リクエスト送信
            const learnResponse = yield axios_1.default.post(API_ENDPOINT, learnRequestContent, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiKey}`,
                },
            });
            const learnResponseData = learnResponse.data;
            const learnResultContent = ((_g = (_f = learnResponseData.choices[0]) === null || _f === void 0 ? void 0 : _f.message) === null || _g === void 0 ? void 0 : _g.content) || "{}";
            console.log("学習結果:", learnResultContent);
            try {
                // JSONをパース
                const learnResult = JSON.parse(learnResultContent);
                const hasNewKnowledge = learnResult.new_knowledge && learnResult.new_knowledge.length > 0;
                const hasUpdateKnowledge = learnResult.update_knowledge &&
                    learnResult.update_knowledge.length > 0;
                // 新しい知識の追加
                if (hasNewKnowledge) {
                    for (const newK of learnResult.new_knowledge) {
                        yield (0, firestore_1.addDoc)((0, firestore_1.collection)(firestore, "knowledge"), {
                            project_id: projectId,
                            name: newK.name,
                            condition: newK.condition,
                            knowledge: newK.knowledge,
                            evaluation: 0, // 初期評価値
                            createdAt: (0, firestore_1.serverTimestamp)(),
                        });
                    }
                }
                // 既存の知識の更新
                if (hasUpdateKnowledge) {
                    for (const updateK of learnResult.update_knowledge) {
                        yield (0, firestore_1.updateDoc)((0, firestore_1.doc)(firestore, "knowledge", updateK.id), {
                            name: updateK.name,
                            condition: updateK.condition,
                            knowledge: updateK.knowledge,
                            updatedAt: (0, firestore_1.serverTimestamp)(),
                        });
                    }
                }
                // 更新結果の表示
                if (hasNewKnowledge || hasUpdateKnowledge) {
                    alert(`知識ベースを更新しました: 
新規追加: ${hasNewKnowledge ? learnResult.new_knowledge.length : 0}件
更新: ${hasUpdateKnowledge ? learnResult.update_knowledge.length : 0}件`);
                    // 知識ベースの再取得
                    yield fetchKnowledge();
                }
                else {
                    alert("知識ベースの更新は必要ありませんでした");
                }
            }
            catch (err) {
                console.error("知識ベース更新処理のパースに失敗しました:", err);
                alert("知識ベース更新処理に失敗しました");
            }
        }
        catch (err) {
            console.error("学習処理に失敗しました:", err);
            alert("学習処理に失敗しました: " +
                (err instanceof Error ? err.message : String(err)));
        }
        finally {
            setIsLearning(false);
            // モーダルをクリア
            closeExecuteModal();
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("section", { className: "hero" },
            react_1.default.createElement("div", { className: "hero-body" },
                react_1.default.createElement("div", { className: "level" },
                    react_1.default.createElement("div", { className: "level-left" },
                        react_1.default.createElement("h1", { className: "title" }, "\u30D7\u30ED\u30F3\u30D7\u30C8\u4E00\u89A7")),
                    react_1.default.createElement("div", { className: "level-right" },
                        react_1.default.createElement("button", { className: "button is-primary", onClick: openCreateModal }, "\u65B0\u898F\u4F5C\u6210"))))),
        react_1.default.createElement("section", { className: "main-section" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", null,
                    "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8ID: ",
                    projectId),
                loading ? (react_1.default.createElement("div", { className: "has-text-centered" },
                    react_1.default.createElement("p", null, "\u30C7\u30FC\u30BF\u3092\u8AAD\u307F\u8FBC\u307F\u4E2D..."),
                    react_1.default.createElement("progress", { className: "progress is-primary", max: "100" }))) : error ? (react_1.default.createElement("div", { className: "notification is-danger" }, error)) : promptList.length === 0 ? (react_1.default.createElement("div", { className: "notification is-info" }, "\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u306F\u307E\u3060\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002")) : (react_1.default.createElement("div", { className: "table-container" },
                    react_1.default.createElement("table", { className: "table is-fullwidth is-striped is-hoverable" },
                        react_1.default.createElement("thead", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("th", null, "ID"),
                                react_1.default.createElement("th", null, "\u30BF\u30A4\u30C8\u30EB"),
                                react_1.default.createElement("th", null, "\u30D7\u30ED\u30F3\u30D7\u30C8\u30C6\u30AD\u30B9\u30C8"),
                                react_1.default.createElement("th", null, "\u5165\u529B\u9805\u76EE"),
                                react_1.default.createElement("th", null, "\u64CD\u4F5C"))),
                        react_1.default.createElement("tbody", null, promptList.map((item) => (react_1.default.createElement("tr", { key: item.id },
                            react_1.default.createElement("td", null, item.id),
                            react_1.default.createElement("td", null, item.prompt_title || "(なし)"),
                            react_1.default.createElement("td", null,
                                react_1.default.createElement("div", { style: { whiteSpace: "pre-wrap" } }, item.prompt_text.length > 100
                                    ? `${item.prompt_text.slice(0, 100)}...`
                                    : item.prompt_text)),
                            react_1.default.createElement("td", null, renderPromptInputs(item.prompt_inputs)),
                            react_1.default.createElement("td", null,
                                react_1.default.createElement("div", { className: "buttons" },
                                    react_1.default.createElement("button", { className: "button is-primary", onClick: () => openEditModal(item) }, "\u7DE8\u96C6"),
                                    react_1.default.createElement("button", { className: "button is-warning", style: {
                                            backgroundColor: "#ff8c00",
                                            color: "white",
                                        }, onClick: () => handleDelete(item.id) }, "\u524A\u9664"),
                                    react_1.default.createElement("button", { className: "button is-success", onClick: () => openExecuteModal(item) }, "\u5B9F\u884C")))))))))))),
        react_1.default.createElement("div", { className: `modal ${isModalOpen ? "is-active" : ""}` },
            react_1.default.createElement("div", { className: "modal-background", onClick: closeModal }),
            react_1.default.createElement("div", { className: "modal-card", style: { width: "100%", maxWidth: "800px" } },
                react_1.default.createElement("header", { className: "modal-card-head" },
                    react_1.default.createElement("p", { className: "modal-card-title" }, editingPrompt ? "プロンプトの編集" : "新規プロンプトの作成"),
                    react_1.default.createElement("button", { className: "delete", "aria-label": "close", onClick: closeModal })),
                react_1.default.createElement("section", { className: "modal-card-body" },
                    react_1.default.createElement("form", { onSubmit: handleSubmit },
                        react_1.default.createElement("div", { className: "field" },
                            react_1.default.createElement("label", { className: "label" }, "\u30D7\u30ED\u30F3\u30D7\u30C8\u30BF\u30A4\u30C8\u30EB"),
                            react_1.default.createElement("div", { className: "control" },
                                react_1.default.createElement("input", { className: "input", type: "text", name: "prompt_title", value: formData.prompt_title, onChange: handleInputChange, placeholder: "\u30D7\u30ED\u30F3\u30D7\u30C8\u306E\u30BF\u30A4\u30C8\u30EB\u3092\u5165\u529B", required: true }))),
                        react_1.default.createElement("div", { className: "field" },
                            react_1.default.createElement("label", { className: "label" }, "\u30D7\u30ED\u30F3\u30D7\u30C8\u30C6\u30AD\u30B9\u30C8"),
                            react_1.default.createElement("div", { className: "control" },
                                react_1.default.createElement("textarea", { className: "textarea", name: "prompt_text", value: formData.prompt_text, onChange: handleInputChange, rows: 10, style: { width: "100%" }, required: true }))),
                        react_1.default.createElement("div", { className: "field" },
                            react_1.default.createElement("label", { className: "label" }, "\u5165\u529B\u9805\u76EE"),
                            inputItems.map((item, index) => (react_1.default.createElement("div", { key: index, className: "field mb-2" },
                                react_1.default.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                                    react_1.default.createElement("div", { className: "control is-expanded", style: { flexGrow: 1 } },
                                        react_1.default.createElement("input", { className: "input", type: "text", placeholder: "\u5165\u529B\u9805\u76EE\u540D", value: item.input_name, onChange: (e) => handleInputItemChange(index, e.target.value), required: true, style: { width: "100%" } })),
                                    react_1.default.createElement("div", { className: "control", style: { marginLeft: "5px" } },
                                        react_1.default.createElement("button", { type: "button", className: "button is-info", onClick: () => insertInputReference(item.input_id), title: "\u30D7\u30ED\u30F3\u30D7\u30C8\u306B\u3053\u306E\u5165\u529B\u306E\u53C2\u7167\u3092\u633F\u5165" }, "\u633F\u5165")),
                                    react_1.default.createElement("div", { className: "control", style: { marginLeft: "5px" } },
                                        react_1.default.createElement("button", { type: "button", className: "button is-danger", onClick: () => removeInputItem(index), disabled: inputItems.length <= 1 }, "\u524A\u9664")))))),
                            react_1.default.createElement("div", { className: "control mt-3" },
                                react_1.default.createElement("button", { type: "button", className: "button is-info", onClick: addInputItem }, "+ \u5165\u529B\u9805\u76EE\u3092\u8FFD\u52A0")),
                            react_1.default.createElement("p", { className: "help" }, "\u5165\u529B\u9805\u76EE\u306F\u3001\u30D7\u30ED\u30F3\u30D7\u30C8\u5185\u3067 \"\u5165\u529B3\" \u306E\u3088\u3046\u306B\u53C2\u7167\u3067\u304D\u307E\u3059\u3002\u633F\u5165\u30DC\u30BF\u30F3\u3092\u62BC\u3059\u3068\u633F\u5165\u3067\u304D\u307E\u3059\u3002")))),
                react_1.default.createElement("footer", { className: "modal-card-foot" },
                    react_1.default.createElement("button", { className: `button is-primary ${isSubmitting ? "is-loading" : ""}`, onClick: handleSubmit, disabled: isSubmitting }, "\u4FDD\u5B58"),
                    react_1.default.createElement("button", { className: "button", onClick: closeModal }, "\u30AD\u30E3\u30F3\u30BB\u30EB")))),
        react_1.default.createElement("div", { className: `modal ${isExecuteModalOpen ? "is-active" : ""}` },
            react_1.default.createElement("div", { className: "modal-background", onClick: closeExecuteModal }),
            react_1.default.createElement("div", { className: "modal-card" },
                react_1.default.createElement("header", { className: "modal-card-head" },
                    react_1.default.createElement("p", { className: "modal-card-title" }, "\u30D7\u30ED\u30F3\u30D7\u30C8\u5B9F\u884C"),
                    react_1.default.createElement("button", { className: "delete", "aria-label": "close", onClick: closeExecuteModal })),
                react_1.default.createElement("section", { className: "modal-card-body" }, executingPrompt && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "content" },
                        react_1.default.createElement("h4", null, executingPrompt.prompt_title
                            ? `${executingPrompt.prompt_title}のプロンプト`
                            : "プロンプトテキスト"),
                        react_1.default.createElement("div", { className: "box", style: {
                                whiteSpace: "pre-wrap",
                                backgroundColor: "#f5f5f5",
                            } }, executingPrompt.prompt_text)),
                    react_1.default.createElement("form", { onSubmit: handleExecute },
                        react_1.default.createElement("h4", null, "\u5165\u529B\u30D1\u30E9\u30E1\u30FC\u30BF"),
                        executingPrompt.prompt_inputs.length === 0 ? (react_1.default.createElement("div", { className: "notification is-info" }, "\u3053\u306E\u30D7\u30ED\u30F3\u30D7\u30C8\u306B\u306F\u5165\u529B\u30D1\u30E9\u30E1\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093\u3002")) : (executingPrompt.prompt_inputs.map((input) => (react_1.default.createElement("div", { className: "field", key: input.input_id },
                            react_1.default.createElement("label", { className: "label" }, input.input_name),
                            react_1.default.createElement("div", { className: "control" },
                                react_1.default.createElement("input", { className: "input", type: "text", name: input.input_name, value: executeInputs[input.input_id] || "", onChange: (e) => handleExecuteInputChange(e, input.input_id), required: true }))))))),
                    isSelectingKnowledge && (react_1.default.createElement("div", { className: "notification is-info" },
                        react_1.default.createElement("p", null, "\u95A2\u9023\u3059\u308BKnowledge\u3092\u691C\u7D22\u4E2D..."),
                        react_1.default.createElement("progress", { className: "progress is-primary", max: "100" }))),
                    selectedKnowledge.length > 0 && (react_1.default.createElement("div", { className: "content mt-4" },
                        react_1.default.createElement("h4", null, "\u5229\u7528\u3055\u308C\u308BKnowledge"),
                        react_1.default.createElement("div", { className: "box", style: { backgroundColor: "#f0f8ff" } }, selectedKnowledge.map((k) => (react_1.default.createElement("div", { key: k.id, className: "mb-3" },
                            react_1.default.createElement("strong", null, k.name),
                            react_1.default.createElement("p", null, k.knowledge))))))),
                    executionResult && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "content mt-5" },
                            react_1.default.createElement("h4", null, "\u5B9F\u884C\u7D50\u679C"),
                            react_1.default.createElement("div", { className: "box", style: {
                                    whiteSpace: "pre-wrap",
                                    backgroundColor: "#f0f8ff",
                                    maxHeight: "300px",
                                    overflow: "auto",
                                } }, executionResult)),
                        react_1.default.createElement("div", { className: "content mt-5" },
                            react_1.default.createElement("h4", null, "\u6821\u6B63"),
                            react_1.default.createElement("div", { className: "control" },
                                react_1.default.createElement("textarea", { className: "textarea", placeholder: "\u51FA\u529B\u5185\u5BB9\u306E\u6821\u6B63\u3084\u4FEE\u6B63\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", value: correctionText, onChange: handleCorrectionChange, rows: 6 })))))))),
                react_1.default.createElement("footer", { className: "modal-card-foot" },
                    react_1.default.createElement("button", { className: `button is-success ${isExecuting ? "is-loading" : ""}`, onClick: handleExecute, disabled: isExecuting }, "\u5B9F\u884C"),
                    executionResult && (react_1.default.createElement("button", { className: `button is-info ${isLearning ? "is-loading" : ""}`, onClick: handleLearn, disabled: isLearning }, "\u5B66\u7FD2")),
                    react_1.default.createElement("button", { className: "button", onClick: closeExecuteModal }, "\u9589\u3058\u308B"))))));
}
exports.default = PromptList;
